import React from 'react';
import { motion } from 'framer-motion';
import '../styles/About.css';

import centerImage from '../assets/logo.png';
import video1 from '../assets/Vid-3.mp4';
import video2 from '../assets/Vid-5.mp4';

const About = () => {
  return (
    <section className="about-section" id="about">
      <motion.h1
        initial={{ opacity: 0, y: -30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        {/* ABOUT US */}
      </motion.h1>

      <motion.p
        className="intro-text"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.3, duration: 0.8 }}
      >
        Apexcel is named after a combination of apex (highest part of something)
        and excel (proficient in an activity). We provide innovative engineering
        solutions, modern equipment rentals, and reliable manpower services to
        power industries forward.
      </motion.p>

      <motion.div
        className="center-image"
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ delay: 0.6, duration: 0.8 }}
      >
        <img src={centerImage} alt="Team working" />
      </motion.div>

      <motion.div
        className="section two-column"
        initial={{ opacity: 0, x: -40 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true, amount: 0.3 }}
      >
        <video
          className="video"
          src={video1}
          autoPlay
          loop
          muted
          playsInline
          preload="auto"
        />
        <p>
        "Apexcel incorporated with a mission to be a part of market in line with evolving trends and expectations through framed facets of our services . As we endeavour to build a commercial portfolio around
our client' space, so our team adopts to meet their requirements individually one at a time."
        </p>
      </motion.div>

      <motion.div
        className="section two-column reverse"
        initial={{ opacity: 0, x: 40 }}
        whileInView={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true, amount: 0.3 }}
      >
        <video
          className="video"
          src={video2}
          autoPlay
          loop
          muted
          playsInline
          preload="auto"
        />
        <p>
        "We provide value driven solutions in services through our multi-disciplinary engineering company. We subject and realise each of our goals through the state-of-the-art processes with highly skilled professionals.we are relentless in moving boundaries to keep our offerings are wide-ranging for commercial facilities with an inclusivity to be one-stop-source"
        </p>
      </motion.div>
    </section>
  );
};

export default About;
